import clsx from "clsx"
import PropTypes from "prop-types"
import { Controller, useFormContext } from "react-hook-form"
import { TiDeleteOutline } from "react-icons/ti"

const MultiSelect = ({ label, id, className, options, ...inputProps }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <Controller
      control={control}
      name={id}
      render={({ field: { value, onChange, onBlur, error } }) => {
        return (
          <div
            className={clsx(
              "flex flex-col mb-4 w-full",
              className && className,
            )}
          >
            <label
              htmlFor={id}
              className="mt-4 mb-2 text-xs text-brand-secondary font-semibold"
            >
              {label}
            </label>
            <select
              id={id}
              className={clsx(
                "border border-gray1 rounded-lg px-4 flex justify-between items-center h-full bg-[transparent] triangle-down-select-icon search-input bg-gray1 text-[12px]",
                className && className,
              )}
              onChange={(e) => {
                onChange([...value, Number(e.target.value)])
              }}
              value=""
            >
              <option value="" disabled>
                Select a client
              </option>

              {options?.map((option) => {
                return (
                  <option
                    key={option.id}
                    value={option.id}
                    disabled={value.includes(option.id)}
                  >
                    {option.name}
                  </option>
                )
              })}
            </select>
            <div className="flex gap-1 mt-2 flex-wrap">
              {value?.map((item, index) => (
                <div
                  key={index}
                  className="border p-2 rounded-xl bg-[#c8e5e7] flex items-center text-[14px] gap-1 flex-wrap"
                >
                  {options.find((o) => o.id === item)?.name}
                  <button
                    onClick={() => {
                      onChange(value.filter((it) => it !== item))
                    }}
                  >
                    <TiDeleteOutline className="w-5 h-5" />
                  </button>
                </div>
              ))}
            </div>
          </div>
        )
      }}
    />
  )
}

MultiSelect.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  options: PropTypes.array,
}

export default MultiSelect
